import React, { Component } from "react";
import {
  Button,
  Container,
  Header,
  Grid
} from "semantic-ui-react";

import BookDisplay from './BookDisplay';

const style = {
  submit : {
    textAlign: "right"
  },
  mainContainer : {
    padding: '0 2em'
  }
};

export default class BookReview extends Component {
  render() {
    return (
      <Container style={style.mainContainer}>
        <Grid>
          <Grid.Row centered>
            <Header as="h1">Review</Header>
          </Grid.Row>
          <BookDisplay
            name={this.props.name}
            email={this.props.email}
            telephone={this.props.telephone}
            pictures={this.props.pictures}
            />
          <Grid.Row columns={2}>
            <Grid.Column>
              <Button onClick={this.props.onBack}>Back</Button>
            </Grid.Column>
            <Grid.Column style={style.submit}>
              <Button primary onClick={this.props.onNext}>
                Submit
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}
